export * from "firebase/auth";

export const AppleAuthProvider = {};
